import { render } from "./FormManterAlimento.vue?vue&type=template&id=6cca6072"
import script from "./FormManterAlimento.vue?vue&type=script&lang=js"
export * from "./FormManterAlimento.vue?vue&type=script&lang=js"

import "./FormManterAlimento.vue?vue&type=style&index=0&id=6cca6072&lang=css"
/* custom blocks */
import block0 from "./FormManterAlimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__